import React, { useEffect, useMemo, useRef, useState } from "react";
import { CloseCircleFilled, CloseCircleOutlined, InfoCircleFilled, CheckCircleFilled, ExclamationCircleFilled } from '@ant-design/icons';
import classes from "./warrantyForm.module.css";

const iconMap = {
    info: <InfoCircleFilled />,
    success: <CheckCircleFilled />,
    error: <CloseCircleFilled />,
    warning: <ExclamationCircleFilled />,
};

const MessageSection = props=>{

    const {alertMessage, setAlertMessage} = props;
    const timersRef = useRef({});

    const removeMessage = () => {
        setAlertMessage([])
    };

    useEffect(() => {
        // 清理已移除的定时器
        Object.keys(timersRef.current).forEach((key) => {
            const stillExists = alertMessage.find((msg) => (msg.key || msg.content) === key);
            if (!stillExists) {
                clearTimeout(timersRef.current[key]);
                delete timersRef.current[key];
            }
        });
        // 为新消息设置自动关闭
        alertMessage.forEach((msg) => {
            const key = msg.key || msg.content;
            if (!timersRef.current[key] && msg.duration && msg.duration > 0) {
                timersRef.current[key] = setTimeout(() => {
                    removeMessage(key);
                }, msg.duration * 1000);
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [alertMessage]);

    return <div className={classes.custom_message_container}>
        {alertMessage.map((msg) => {
            const key = msg.key || msg.content;
            return (
                <div key={key} className={`${classes.custom_message} ${classes['custom_message_'+msg.type]}`}>
                    <div className={classes.custom_message_icon}>{iconMap[msg.type]}</div>
                    <div className={classes.custom_message_content}>{msg.content}</div>
                    {msg.duration === 0 && (
                        <div className={classes.custom_message_close} onClick={(e) =>{
                            e.stopPropagation(); removeMessage(key)
                        }}>
                            <CloseCircleOutlined />
                        </div>
                    )}
                </div>
            );
        })}
    </div>;
}

export default MessageSection;